// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BadgeModalController from "./badge_modal_controller"
application.register("badge-modal", BadgeModalController)

import BridgeButtonController from "./bridge/button_controller"
application.register("bridge--button", BridgeButtonController)

import BridgeMenuController from "./bridge/menu_controller"
application.register("bridge--menu", BridgeMenuController)

import BridgeNavButtonController from "./bridge/nav_button_controller"
application.register("bridge--nav-button", BridgeNavButtonController)

import BridgeNativeNotificationBadgeController from "./bridge/native_notification_badge_controller"
application.register("bridge--native-notification-badge", BridgeNativeNotificationBadgeController)

import BottleAiFormController from "./bottle_ai_form_controller"
application.register("bottle-ai-form", BottleAiFormController)

import CellarMapController from "./cellar_map_controller"
application.register("cellar-map", CellarMapController)

import CurrentUserMarkerController from "./current_user_marker_controller"
application.register("current-user-marker", CurrentUserMarkerController)

import DatetimePickerController from "./datetime_picker_controller"
application.register("datetime-picker", DatetimePickerController)

import DevToolsController from "./dev_tools_controller"
application.register("dev-tools", DevToolsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EventFreshnessController from "./event_freshness_controller"
application.register("event-freshness", EventFreshnessController)

import EventPrivacyController from "./event_privacy_controller"
application.register("event-privacy", EventPrivacyController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import InfoModalController from "./info_modal_controller"
application.register("info-modal", InfoModalController)

import NativeDeviceTokenBridgeController from "./native/device_token_bridge_controller"
application.register("native--device-token-bridge", NativeDeviceTokenBridgeController)

import MultiselectController from "./multiselect_controller"
application.register("multiselect", MultiselectController)

import NotificationBadgeController from "./notification_badge_controller"
application.register("notification-badge", NotificationBadgeController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import SortableListController from "./sortable_list_controller"
application.register("sortable-list", SortableListController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import PullToRefreshController from "./pull_to_refresh_controller"
application.register("pull-to-refresh", PullToRefreshController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import TypingController from "./typing_controller"
application.register("typing", TypingController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import RichEditorController from "./rich_editor_controller"
application.register("rich-editor", RichEditorController)

import ReaderController from "./reader_controller"
application.register("reader", ReaderController)
